var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnselectedEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1848 15.1589L22.3694 10.5888L7.57369 0.564087L0.549453 20.1713C-0.0483541 21.7929 0.549453 23.7094 2.19342 24.7414L3.83739 25.7733C4.4352 26.2156 5.18246 26.363 5.92972 26.363C6.97588 26.363 8.02204 25.9207 8.91875 25.0362L11.1605 22.6774L12.3561 23.8568C12.8045 24.2991 13.5518 24.5939 14.1496 24.5939H14.299C15.0463 24.5939 15.6441 24.2991 16.2419 23.7094L19.6793 20.0238C20.7254 18.9919 20.576 17.2228 19.5298 16.3383L18.1848 15.1589ZM7.27478 23.7094C6.67698 24.2991 5.78026 24.4465 5.18246 24.0042L3.38904 22.9723C2.79123 22.53 2.49233 21.7929 2.79123 21.0558L8.61985 4.10222L18.7826 11.0311L7.27478 23.7094ZM17.8859 18.697L14.4485 22.3826C14.299 22.53 14.299 22.53 14.1496 22.53C14.1496 22.53 14.0001 22.53 13.8507 22.3826L12.655 21.2032L16.6902 16.928L17.8859 18.1074C18.0353 18.2548 18.0353 18.5496 17.8859 18.697Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnselectedEvents);
export default __webpack_public_path__ + "static/media/unselected-events.07802590671811e13a71eda83bed1240.svg";
export { ForwardRef as ReactComponent };